var map = {
	"./APRILYOS/login-background.png": "hVrt",
	"./LNI/login-background.png": "b6g1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CNpI";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/login\-background\.png$
// module id = CNpI
// module chunks = 0